// extracted by mini-css-extract-plugin
export default {"hiddenInput":"LamodaFile_hiddenInput__B7skt","container":"LamodaFile_container__0RyJP"};